import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router'

import { asyncError, createOrder, saveOrder } from 'redux/actions'
import * as routes from 'settings/_routesSettings'

interface Payload {
  person_profile_product_appointment_id: number
  plan_code: string
  product_group_code: string
  profile_role: string
  username: string
  schedules: Array<{
    start_date: string
    end_date: string
    guests: Array<{
      person_profile_id: number
    }>
  }>
  scheduledFrom: string
}

interface ICreateOrder {
  isCreateOrderLoading: boolean
  onCreateOrder: (payload: Payload) => void
}

type AuthState = {
  auth: { 
    isAuth: boolean 
  }
}

export function useCreateOrder(): ICreateOrder {
  const [isCreateOrderLoading, setIsCreateOrderLoading] = useState(false)
  const dispatch = useDispatch()
  const routeMatch = useRouteMatch()
  const history = useHistory()
  const isAuth = useSelector((state: AuthState) => state.auth.isAuth)
  
  async function onCreateOrder(payload: Payload) {
    const selectedSchedule = payload?.schedules[0]?.start_date
    if (!isAuth) {
      const redirectUrl = encodeURI(
        `${routeMatch.url}?availabilities=${JSON.stringify(selectedSchedule)}`
      )
      return history.push(`${routes.LOGIN}?redirectTo=${redirectUrl}`)
    }

    try {
      setIsCreateOrderLoading(true)
      dispatch(saveOrder(payload))
      await dispatch(createOrder(payload, true))
    } catch (error) {
      dispatch(asyncError(error))
    } finally {
      setIsCreateOrderLoading(false)
    }
  }
  
  return {
    isCreateOrderLoading,
    onCreateOrder
  }
}